import colors from "../../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const SignUpFormStyle = makeStyles((theme) => ({
	fieldRow: {
		display: "flex",
		gap: theme.spacing(2),
		width: "100%",
		flexWrap: "wrap",
	},
	field: {
		margin: theme.spacing(1),
		flex: "1 1 45%",
		minWidth: 200,
	},
	centerRow: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: theme.spacing(2),
		width: "100%",
		flexWrap: "wrap",
	},
	submitWrapper: {
		display: "flex",
		alignContent: "center",
		justifyContent: "center",
		width: "100%",
	},
	submitButton: {
		width: "45%",
	},
	paper: {
		paddingTop: theme.spacing(14),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%",
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
		color: colors.white,
		fontWeight: "bold",
		backgroundColor: colors.primary,
		"&:hover": {
			backgroundColor: colors.darkCrimsonRed,
		},
	},
	loaderContainer: {
		paddingTop: "10px",
	},
	loader: {
		height: "30px",
	},
	passwordPolicy: {
		fontSize: "12px",
		padding: "4px 0",
	},
	filledPasswordPolicy: {
		color: colors.brightGreen,
	},
	pendingPasswordPolicy: {
		color: colors.white,
	},
	signupContainer: {
		maxWidth: "888px",
	},
	signinLink: {
		display: "flex",
		alignContent: "center",
		justifyContent: "center",
	},
	signinBox: {
		width: "45%",
	},
}));

export default SignUpFormStyle;
